﻿import classNames from "classnames";
import { delayOnOutsideClick } from "helpers";
import { createLogger } from "logging";
import { NavigationModel } from "models/NavigationModel";
import { Language, useTranslations } from "providers";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

import { HeaderDropdownItem } from "./HeaderDropdownItem";

const logger = createLogger("LanguageMenu");

interface LanguageMenuProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const LanguageMenu: React.FC<LanguageMenuProps> = ({ isOpen, setIsOpen }) => {
  const outsideClickRef = useRef<HTMLDivElement>(null!);
  useOnClickOutside(outsideClickRef, () => {
    delayOnOutsideClick(logger, isOpen, setIsOpen);
  });

  const i18n = useTranslations();

  const getLanguageLabel = (language: Language) => {
    switch (language) {
      case Language.FR:
        return i18n.Header_French;
      case Language.IT:
        return i18n.Header_Italian;
      case Language.EN:
        return i18n.Header_English;
      default:
        return i18n.Header_German;
    }
  };

  const items: NavigationModel[] = [];
  function addLanguage(items: NavigationModel[], lang: Language) {
    items.push({
      onClick: () => {
        i18n.changeLanguage(lang);
      },
      text: getLanguageLabel(lang),
      isSelected: i18n.currentLanguage == lang,
    });
  }
  addLanguage(items, Language.DE);
  addLanguage(items, Language.FR);
  addLanguage(items, Language.IT);
  addLanguage(items, Language.EN);

  const buttonId = "languageMenuButton";
  const buttonClass = classNames("btn", "btn-link", "dropdown-toggle", isOpen ? "show" : "");
  const menuClass = classNames("dropdown-menu", isOpen ? "show" : "");
  return (
    <div className="sbb-header-nav-item" ref={outsideClickRef}>
      <div className="dropdown" onClick={() => setIsOpen(!isOpen)} aria-hidden="true">
        <button
          className={buttonClass}
          type="button"
          id={buttonId}
          aria-haspopup="true"
          aria-expanded={isOpen ? "true" : "false"}
        >
          <div className="sbb-header-nav-item-icon me-1">
            <i className="ms-Icon ms-Icon--Globe" />
          </div>
          <div className="sbb-header-nav-item-text hide-on-mobile">{getLanguageLabel(i18n.currentLanguage)}</div>
          <div className="sbb-header-nav-item-icon ms-2">
            <i className="ms-Icon ms-Icon--ChevronDown" />
          </div>
        </button>

        <div className={menuClass} aria-labelledby={buttonId}>
          <div className="dropdown-inner">
            {items.map((item, i) => (
              <HeaderDropdownItem key={`languagemenu-${i}`} item={item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
